export default "__VITE_ASSET__CI6rPFvG__"